import React from "react";
import Helmet from "react-helmet";
import { graphql } from "gatsby";

import BorderButton from "../components/BorderButton";
import Testimonial from "../components/Testimonial";
import PagesTemplate from "./_template";

export const query = graphql`
  {
    site {
      siteMetadata {
        siteTitle
        loginLink
        signupLink
      }
    }
  }
`;

export default class Index extends React.Component {
  render() {
    return (
      <PagesTemplate showHero>
        <div>
          <Helmet
            title="Automatic text message surveys for better customer experience"
            meta={[
              {
                name: "description",
                content:
                  "O3 creates tools to help business measure customer and patient satisfaction and performance",
              },
              {
                name: "keywords",
                content:
                  "O3, perspexi labs, business analytics, customer satisfaction, customer experience, text message surveys, digital health, patient satisfaction, outcome measures",
              },
            ]}
          />

          <h2 className="f1 lh-title tc mw7 center pv4">
            Outreach<sup style={{ color: "#666" }}>™</sup> collects customer
            satisfaction data automatically via text messages.
          </h2>

          <section className="cf pv4 tc">
            <div className="mw8 center">
              <div className="fl-ns w-third-ns ph4 grow">
                <img
                  src="/img/chat-2x.png"
                  alt="Send and receive customer satisfaction data via text messages"
                  style={{ maxHeight: 196, maxWidth: 196 }}
                />
                <span className="f5 lh-copy db mv2">
                  Get instant feedback via high response, automated text
                  messages.
                </span>
                <BorderButton label="Learn More" link="/outreach/features/" />
              </div>
              <div className="fl-ns w-third-ns ph4 grow">
                <img
                  src="/img/medal-2x.png"
                  alt="Find top performing employees based on customer feedback"
                  style={{ maxHeight: 196, maxWidth: 196 }}
                />
                <span className="f5 lh-copy db mv2">
                  Identify top performing employees&mdash;your customers&apos;
                  superheros.
                </span>
                <BorderButton label="Learn More" link="/outreach/features/" />
              </div>
              <div className="fl-ns w-third-ns ph4 grow">
                <img
                  src="/img/celebrate-2x.png"
                  alt="Resolve issues with detractors and reward promoters"
                  style={{ maxHeight: 196, maxWidth: 196 }}
                />
                <span className="f5 lh-copy db mv2">
                  Resolve issues before they blow up and reward your most loyal
                  customers.
                </span>
                <BorderButton label="Learn More" link="/outreach/features/" />
              </div>
            </div>
          </section>

          <section className="mv4 bg-near-white">
            <div className="mw8 center">
              <div className="w-50-ns dib v-mid">
                <h3 className="f2 lh-title tc mv0 pb6-ns pt2">
                  Our customers love us:
                </h3>
              </div>
              <div className="w-50-ns dib v-mid">
                <Testimonial
                  imgPath="/img/testimonial-pics/jeremy.jpg"
                  name="Jeremy L., Owner, Preventive Pest Control"
                >
                  I&apos;ve been <em>blown away</em> by how useful O3 has been
                  for us. We work so hard to train our employees to give great
                  experiences to our customers, and I <em>love</em> being able
                  to read customer comments and see it in action.
                </Testimonial>
              </div>
            </div>
          </section>

          <section className="tc pt3 pb5">
            <h3 className="f2 lh-title tc mw7 center pb1">
              400,000+ of surveys sent. Discover the power of O3 with your
              customers today.
            </h3>
            <BorderButton
              label="Start a Free Trial"
              link={this.props.data.site.siteMetadata.signupLink}
              primary
              color="blue"
            />
            <BorderButton label="Learn More" link="/outreach/features/" />
          </section>
        </div>
      </PagesTemplate>
    );
  }
}
